import { useEffect } from "react";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

export function CustomCSSLoader() {
  const { settings } = useSiteSettings();

  useEffect(() => {
    // Remove existing custom style tag if present
    const existingStyle = document.getElementById("custom-css-override");
    if (existingStyle) {
      existingStyle.remove();
    }

    // Add new custom CSS if available
    if (settings.custom_css) {
      const styleTag = document.createElement("style");
      styleTag.id = "custom-css-override";
      styleTag.textContent = settings.custom_css;
      document.head.appendChild(styleTag);
    }

    return () => {
      const styleTag = document.getElementById("custom-css-override");
      if (styleTag) {
        styleTag.remove();
      }
    };
  }, [settings.custom_css]);

  useEffect(() => {
    const color = settings.site_body_text_color;
    const styleTag = document.createElement("style");
    styleTag.id = "site-body-text-color";
    if (/^#[\da-fA-F]{6}$/.test(color)) {
      styleTag.textContent = `.public-site { --public-body-copy: ${hexToHsl(color)}; }`;
      document.head.appendChild(styleTag);
    }
    return () => styleTag.remove();
  }, [settings.site_body_text_color]);

  useEffect(() => {
    const color = settings.site_heading_text_color;
    const styleTag = document.createElement("style");
    styleTag.id = "site-heading-text-color";
    if (/^#[\da-fA-F]{6}$/.test(color)) {
      styleTag.textContent = `.public-site { --public-heading-copy: ${hexToHsl(color)}; }`;
      document.head.appendChild(styleTag);
    }
    return () => styleTag.remove();
  }, [settings.site_heading_text_color]);

  return null;
}

function hexToHsl(hex: string) {
  const [r, g, b] = [1, 3, 5].map((offset) => parseInt(hex.slice(offset, offset + 2), 16) / 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;
  const lightness = (max + min) / 2;
  if (delta === 0) return `0 0% ${(lightness * 100).toFixed(2)}%`;
  const saturation = delta / (1 - Math.abs(2 * lightness - 1));
  let hue = max === r ? ((g - b) / delta) % 6 : max === g ? (b - r) / delta + 2 : (r - g) / delta + 4;
  hue = (hue * 60 + 360) % 360;
  return `${hue.toFixed(2)} ${(saturation * 100).toFixed(2)}% ${(lightness * 100).toFixed(2)}%`;
}
